var _excluded = ["size", "children", "className", "width", "height"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable custom-rules/need-data-qa */
import * as React from "react";
import { sizes } from "./iconSizes";
var IconBase = _ref => {
  var {
      size,
      children,
      className,
      width,
      height
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  var sizeDimension = sizes[size];
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: className,
    width: width || sizeDimension,
    height: height || sizeDimension,
    viewBox: "0 0 ".concat(width || sizeDimension, " ").concat(height || sizeDimension)
  }, rest), children);
};
export default IconBase;